export default __webpack_public_path__ + "static/media/english.8be9e28d.svg";